"use client";

import { DIALER_SYSTEMS, type DialerCarrier } from "@/app/_module/utils/dialerSystem";

const SYSTEMS: DialerCarrier[] = ["twilio", "telnyx"];

/** Which InsuraDialer system new numbers are bought on. Rendered only when Next is available. */
export function DialerSystemChoice({
  value,
  current,
  onChange,
}: {
  value: DialerCarrier;
  current: DialerCarrier;
  onChange: (c: DialerCarrier) => void;
}) {
  return (
    <div className="rounded-lg border p-4 space-y-3">
      <div>
        <p className="font-medium">Buy numbers on</p>
        <p className="text-sm text-muted-foreground">
          Each number belongs to one InsuraDialer system. Your dialer runs on the system of your default number.
        </p>
      </div>
      <div className="grid gap-2 sm:grid-cols-2" role="radiogroup" aria-label="Dialer system for new numbers">
        {SYSTEMS.map((c) => (
          <button
            key={c}
            type="button"
            role="radio"
            aria-checked={value === c}
            onClick={() => onChange(c)}
            className={`text-left rounded-md border p-3 transition-colors focus-visible:!outline-none focus-visible:!ring-2 focus-visible:!ring-primary ${
              value === c ? "border-primary bg-primary/5 ring-1 ring-primary" : "hover:bg-muted/50"
            }`}
          >
            <span className="flex flex-wrap items-center gap-2 font-medium">
              {DIALER_SYSTEMS[c].name}
              {c === current && <span className="text-xs font-normal text-muted-foreground">Your dialer now</span>}
            </span>
            <span className="block text-xs text-muted-foreground mt-0.5">{DIALER_SYSTEMS[c].blurb}</span>
          </button>
        ))}
      </div>
      {value !== current && (
        <p className="text-sm text-amber-900 bg-amber-50 border border-amber-200 rounded p-2">
          {DIALER_SYSTEMS[value].name} numbers make and take calls once it is your dialer system. Switch in
          Settings, Dialer after buying.
          {value === "telnyx" && " Texting on Next needs its own A2P registration."}
        </p>
      )}
    </div>
  );
}
